import type { ReactElement } from 'react';
import { quizTalkLine } from '../../../../../shared/quiz-handoff.js';
import { GamesTalkHandoff } from './GamesTalkHandoff';

/**
 * Where Ember games' quiz hands a person to Ember (2026-10-22 jam: the quiz
 * lives in its own project now). The link carries only the animal and the
 * topic; the first line is written from them (shared/quiz-handoff.js). The
 * page itself is the games' shared one (GamesTalkHandoff, 2026-10-23).
 */
export function QuizTalkHandoff({ search }: { search: URLSearchParams }): ReactElement {
  return (
    <GamesTalkHandoff
      line={quizTalkLine(search.get('quiz'), search.get('topic'))}
      discovery="quiz"
    />
  );
}
